import axios from '../../utils/axios';

export default function fetchLGCollectionTargets(adminId, params = {}) {
    return (
        axios.get(`/admin/${adminId}/allLGCollectionTargets`,  {params} )
    )
}
